var render = function render(){var _vm=this,_c=_vm._self._c;return _c('improve-your-results-template',{attrs:{"patient-photo":_vm.patientPhoto},on:{"back":_vm.onBack,"continue":_vm.onContinue,"skip":_vm.onSkip}})
}
var staticRenderFns = []

export { render, staticRenderFns }